import { Injectable } from "@angular/core";
import { InputTextRenderer } from "src/app/shared/renderers/input-text/input-text.component";
import { Constants } from "src/app/shared/utils/constants";
import { EEAGapLogicService } from "../eea-gap.logic.service";
import { ViewPwcScenariosButtonRenderer } from "src/app/shared/renderers/view-pwc-scenarios-button/view-pwc-scenarios-button.component";
import { MasterDetailsCalendarComponent } from "src/app/shared/renderers/master-detail-calendar/master-details-calendar/master-details-calendar.component";
import { DuplicateButtonRenderer } from "src/app/shared/renderers/duplicate-button/duplicate-button.component";
import { InputTextApplicationSchemeRenderer } from "src/app/shared/renderers/input-text/input-text-application-scheme/input-text-application-scheme.component";
import { EndpointDatasetLogicService } from "src/app/shared/components/endpoint-dataset/endpoint-dataset.logic.service";
import { Project } from "src/app/shared/models/project";
import { isPwcV2Project } from "src/app/shared/utils/pwc-version.utils";

@Injectable({
    providedIn: 'root'
})
export class EEAGapPWCSurfaceWaterV2Coldef {

    constructor(
        private eEAGapLogicService: EEAGapLogicService,
        private logicService: EndpointDatasetLogicService
    ) { }

    public getPWCColumnsDefinition(options: any, isProjectOwnershipValid: boolean, selectedProject?: Project): any[] {
        console.log("Getting PWC Columns Definition", options);
        return [
            {
                headerName: '',
                field: 'select',
                type: 'default',
                headerCheckboxSelection: isProjectOwnershipValid,
                width: 50,
                hide: false,
                editable: false,
                pinned: 'left',
                checkboxSelection: () => { return isProjectOwnershipValid },
                cellStyle: () => {
                    return !isProjectOwnershipValid ? { pointerEvents: 'none', backgroundColor: '#f0f0f0' }
                        : undefined;
                }
            },
            {
                headerName: 'Application Scheme',
                headerComponent: 'infoGridHeaderComponentComponent',
                headerComponentParams: {
                    name: 'Application Scheme',
                    infoText: Constants.MESSAGES.APP_SCHEME_INFO,
                    popupWidth: 450
                },
                field: 'name',
                type: 'default',
                resizable: true,
                pinned: "left",
                filter: 'agSetColumnFilter',
                cellRenderer: InputTextApplicationSchemeRenderer,
                cellRendererParams: {
                    disabled: !isProjectOwnershipValid,
                    isRequired: true
                },
                editable: false,
                cellEditorParams: {
                    maxLength: 200,
                },
            },
            {
                headerName: 'Scenarios',
                type: 'default',
                width: 100,
                editable: false,
                resizable: false,
                cellRenderer: ViewPwcScenariosButtonRenderer,
                cellRendererParams: (params: any) => {
                    return {
                        label: 'Select',
                        disabled: !params.data.name,
                        showOverlay: true,
                        field: 'scenarios'
                    };
                }
            },
            {
                headerName: 'Date Type',
                field: 'dateType',
                resizable: true,
                width: 140,
                wrapText: true,
                type: 'default',
                filter: 'agSetColumnFilter',
                editable: false,
                cellRenderer: 'dropdownlistRenderer',
                cellRendererParams: (params: any) => {
                    return {
                        options: Constants.DATE_TYPES,
                        columnThatModifies: 'dateType',
                        disabled: !isProjectOwnershipValid,
                    };
                }
            },
            {
                headerName: 'Crop Events',
                field: 'cropEvent',
                type: 'selected',
                width: 140,
                resizable: true,
                hide: false,
                filter: 'agSetColumnFilter',
                editable: false,
                cellRenderer: 'dropdownlistRenderer',
                cellRendererParams: (params: any) => {
                    if (!params || !params.data) return {};
                    return {
                        options: options.cropEvents,
                        optionValue: 'id',
                        optionLabel: 'name',
                        columnThatModifies: 'cropEvent',
                        disabled: !isProjectOwnershipValid || this.eEAGapLogicService.disableCropEvent(params.data.dateType),
                    };
                },
            },
            {
                headerName: 'Specify Years',
                field: 'specifyYears',
                editable: false,
                type: 'selected',
                width: 130,
                wrapText: true,
                hide: !this.logicService.isPwcProject(selectedProject!) || this.logicService.isPwcV2 || (selectedProject && isPwcV2Project(selectedProject)),
                cellRenderer: 'checkBoxRenderer',
                cellRendererParams: (params: any) => {
                    return {
                        instance: this,
                        columnThatModifies: 'specifyYears',
                        disabled: !isProjectOwnershipValid,
                    };
                },
            },
            {
                headerName: 'Number of Applications',
                field: 'numberOfApplications',
                type: 'selected',
                isRequired: true,
                minWidth: 120,
                maxWidth: 120,
                wrapText: true,
                filter: 'agSetColumnFilter',
                cellRenderer: 'dropdownlistRenderer',
                cellRendererParams: (params: any) => {
                    if (!params || !params.data) return {};
                    if (!params.data.numberOfApplications) {
                        params.data.numberOfApplications = 1;
                    }
                    return {
                        instance: this,
                        options: options.numbersOfApplication,
                        optionValue: 'value',
                        optionLabel: 'value',
                        columnThatModifies: 'numberOfApplications',
                        disabled: !isProjectOwnershipValid,
                    };
                },
                valueFormatter: (params: any) => {
                    return params.value || 1;
                },
            },
            {
                headerName: 'Application',
                editable: isProjectOwnershipValid,
                cellRenderer: 'agGroupCellRenderer',
                resizable: true,
                type: 'default',
            },
            {
                headerName: 'Application Occur every Year(s)',
                field: 'applicationOccurEveryYears',
                width: 155,
                wrapHeaderText: true,
                resizable: true,
                cellDataType: 'number',
                cellRenderer: InputTextRenderer,
                filter: 'agSetColumnFilter',
                cellRendererParams: (params: any) => {
                    return {
                        disabled: !isProjectOwnershipValid,
                    };
                },
                editable: false,
            },
            {
                headerName: 'Application Occur from year',
                field: 'applicationOccurFromYear',
                width: 155,
                wrapHeaderText: true,
                resizable: true,
                cellDataType: 'number',
                cellRenderer: InputTextRenderer,
                filter: 'agSetColumnFilter',
                cellRendererParams: (params: any) => {
                    return {
                        disabled: !isProjectOwnershipValid,
                    };
                },
                editable: false,
            },
            {
                headerName: 'Application Occur to year',
                field: 'applicationOccurToYear',
                width: 155,
                wrapHeaderText: true,
                resizable: true,
                cellRenderer: InputTextRenderer,
                filter: 'agSetColumnFilter',
                cellRendererParams: (params: any) => {
                    return {
                        disabled: !isProjectOwnershipValid,
                    };
                },
                editable: false,
            },
            {
                headerName: 'Apply pesticide over a time window - Windows (days)',
                wrapHeaderText: true,
                width: 140,
                field: 'windowsDaysToWindowsDays',
                hide: !this.logicService.isPwcProject(selectedProject!) || this.logicService.isPwcV2 || (selectedProject && isPwcV2Project(selectedProject)),
                cellDataType: 'number',
                cellRenderer: InputTextRenderer,
                cellRendererParams: {
                    disabled: !isProjectOwnershipValid,
                },
                editable: false,
                filter: 'agSetColumnFilter'
            },
            {
                headerName: 'Apply pesticide over a time window - Steps (days)',
                width: 130,
                wrapHeaderText: true,
                field: 'stepDaysToStepDays',
                hide: !this.logicService.isPwcProject(selectedProject!) || this.logicService.isPwcV2 || (selectedProject && isPwcV2Project(selectedProject)),
                resizable: true,
                filter: 'agSetColumnFilter',
                cellDataType: 'number',
                cellRenderer: InputTextRenderer,
                cellRendererParams: {
                    disabled: !isProjectOwnershipValid,
                },
                editable: false,
            },
            {
                headerName: '',
                colId: 'duplicate',
                field: 'duplicateButton',
                cellRenderer: DuplicateButtonRenderer,
                type: 'rightAligned',
                width: 130,
                cellRendererParams: {
                    disabled: !isProjectOwnershipValid,
                    mainTablePkName: "applicationSchemePk"
                }
            },
            {
                headerName: '',
                colId: 'delete',
                field: 'deleteButton',
                cellRenderer: 'deleteButtonRenderer',
                type: 'rightAligned',
                cellRendererParams: {
                    disabled: !isProjectOwnershipValid
                }
            }
        ];
    }

    public static getPWCDetailsColumnsDefination(options: any, isProjectOwnershipValid: boolean, selectedProject?: Project): any[] {
        return [
            {
                headerName: '',
                children: [
                    {
                        headerName: 'Application Number',
                        field: 'application_number',
                        type: 'select',
                        minWidth: 105,
                        width: 105,
                        maxWidth: 110,
                        wrapText: true,
                        wrapHeaderText: true,
                        autoHeaderHeight: true,
                        filter: 'agSetColumnfilter',
                        editable: false,
                        cellRenderer: 'dropdownlistRenderer',
                        cellRendererParams: (params: any) => {
                            return {
                                options: options.numbersOfApplication,
                                optionValue: 'value',
                                optionLabel: 'value',
                                columnThatModifies: 'application_number',
                                disabled: !isProjectOwnershipValid,
                            };
                        },
                    },
                ],
            },
            {
                headerName: 'Rate (kg/ha)',
                children: [
                    {
                        headerName: 'Default Active Ingredient',
                        field: 'defaultAI',
                        minWidth: 240,
                        isRequired: true,
                        width: 280,
                        wrapHeaderText: true,
                        autoHeaderHeight: true,
                        type: 'leftAligned',
                        editable: isProjectOwnershipValid,
                    },
                ],
            },
            {
                headerName: '',
                children: [
                    {
                        headerName: 'Application Date',
                        headerValueGetter: (params: any) => {
                            const firstRow = params.api?.getDisplayedRowAtIndex?.(0)?.data;
                            return firstRow?.dateType === Constants.DATE_TYPE_VALUES.RELATIVE
                                ? 'Year'
                                : 'Application Date';
                        },
                        field: 'application_date',
                        minWidth: 140,
                        width: 140,
                        maxWidth: 140,
                        wrapHeaderText: true,
                        autoHeaderHeight: true,
                        type: 'leftAligned',
                        filter: 'agSetColumnFilter',
                        cellRenderer: MasterDetailsCalendarComponent,
                        editable: (params: any) => {
                            if (params.data.specifyYears && params.data.dateType === Constants.DATE_TYPE_VALUES.RELATIVE) return isProjectOwnershipValid;
                            return isProjectOwnershipValid && params.data.dateType === Constants.DATE_TYPE_VALUES.ABSOLUTE ? true : false;
                        },
                        cellRendererParams: (params: any) => {
                            const isAbsolute = params?.data?.dateType === Constants.DATE_TYPE_VALUES.ABSOLUTE;
                            const isRelative = params?.data?.dateType === Constants.DATE_TYPE_VALUES.RELATIVE;
                            const isSpecifyYears = !!params?.data?.specifyYears;
                            const isYearMode = isRelative && isSpecifyYears;
                            const isEnabled = isAbsolute || (isRelative && isYearMode);
                            const highlightDate = isSpecifyYears
                                ? new Date(new Date().getFullYear(), 0, 1)
                                : new Date(2001, 0, 1);
                            return {
                                disabled: !isEnabled || !isProjectOwnershipValid,
                                columnThatModifies: 'application_date',
                                highlightDate,
                                editable: isProjectOwnershipValid && isEnabled,
                                format: isYearMode ? 'yy' : (isAbsolute && isSpecifyYears ? 'dd-M-yy' : 'dd-M'),
                                view: isYearMode ? 'year' : 'date',
                            };
                        },
                        cellStyle: (params: any) => {
                            const isAbsolute = params?.data?.dateType === Constants.DATE_TYPE_VALUES.ABSOLUTE;
                            const isRelativeWithYears = params?.data?.dateType === Constants.DATE_TYPE_VALUES.RELATIVE && params?.data?.specifyYears;
                            if (isAbsolute || isRelativeWithYears) {
                                return !isProjectOwnershipValid ? { backgroundColor: '#f0f0f0' } : null;
                            }
                            return { 'background-color': '#f0f0f0d7' };
                        },
                    },
                    {
                        headerName: 'Days Since',
                        field: 'days_since',
                        minWidth: 90,
                        width: 95,
                        hide: false,
                        wrapHeaderText: true,
                        autoHeaderHeight: true,
                        maxWidth: 105,
                        editable: (params: any) => {
                            if (params.data.dateType === Constants.DATE_TYPE_VALUES.RELATIVE && isProjectOwnershipValid) {
                                return true;
                            }
                            return false;
                        },
                        cellStyle: (params: any) => {
                            if (params.data.dateType === Constants.DATE_TYPE_VALUES.ABSOLUTE) {
                                return { 'background-color': '#f0f0f0d7' };
                            }
                            return !isProjectOwnershipValid ? { backgroundColor: '#f0f0f0' } : null;
                        },
                        valueFormatter: (params: any) => {
                            if (params.value == undefined && params.data.dateType === Constants.DATE_TYPE_VALUES.RELATIVE) return '';
                            return params.value;
                        },
                        type: 'leftAligned',
                        filter: 'agSetColumnFilter',
                    },
                    {
                        headerName: 'Application Method',
                        field: 'application_method',
                        type: 'select',
                        wrapHeaderText: true,
                        autoHeaderHeight: true,
                        minWidth: 145,
                        width: 160,
                        maxWidth: 180,
                        filter: 'agSetColumnfilter',
                        editable: false,
                        cellRenderer: 'dropdownlistRenderer',
                        cellRendererParams: (params: any) => {
                            const excludedMethods = ['T Band', '△', '▽'];
                            const filteredMethods = selectedProject && isPwcV2Project(selectedProject)
                                ? options.applicationMethods?.filter((m: any) => !excludedMethods.includes(m.name))
                                : options.applicationMethods;
                            return {
                                instance: this,
                                options: filteredMethods,
                                optionValue: 'id',
                                optionLabel: 'name',
                                columnThatModifies: 'application_method',
                                disabled: !isProjectOwnershipValid,
                            };
                        },
                    },
                    {
                        headerName: 'Depth (cm)',
                        field: 'depth',
                        minWidth: 90,
                        width: 95,
                        wrapHeaderText: true,
                        autoHeaderHeight: true,
                        maxWidth: 110,
                        editable: isProjectOwnershipValid,
                        type: 'leftAligned',
                        filter: 'agSetColumnFilter',
                    },
                    {
                        headerName: 'T-Band Split',
                        field: 't_band_split',
                        hide: !selectedProject || isPwcV2Project(selectedProject),
                        minWidth: 105,
                        wrapHeaderText: true,
                        autoHeaderHeight: true,
                        editable: isProjectOwnershipValid,
                        width: 115,
                        maxWidth: 125,
                        type: 'leftAligned',
                        filter: 'agSetColumnFilter',
                    }
                ],
            },
            {
                headerName: 'Reservoir',
                children: [
                    {
                        headerName: 'Efficiency',
                        field: Constants.FIELD_NAMES.EFFICIENCY,
                        editable: isProjectOwnershipValid,
                        wrapHeaderText: true,
                        autoHeaderHeight: true,
                        minWidth: 110,
                        width: 110,
                        maxWidth: 120,
                        type: 'leftAligned',
                        filter: 'agSetColumnFilter',
                    },
                    {
                        headerName: 'Drift',
                        field: Constants.FIELD_NAMES.RESERVOIR_DRIFT,
                        editable: isProjectOwnershipValid,
                        wrapHeaderText: true,
                        autoHeaderHeight: true,
                        minWidth: 95,
                        width: 105,
                        maxWidth: 120,
                        type: 'leftAligned',
                        filter: 'agSetColumnFilter',
                    },
                ],
            },
            {
                headerName: 'Pond',
                children: [
                    {
                        headerName: 'Efficiency',
                        field: Constants.FIELD_NAMES.POND_EFFICIENCY,
                        editable: isProjectOwnershipValid,
                        wrapHeaderText: true,
                        autoHeaderHeight: true,
                        minWidth: 110,
                        width: 110,
                        maxWidth: 120,
                        type: 'leftAligned',
                        filter: 'agSetColumnFilter',
                    },
                    {
                        headerName: 'Drift',
                        field: Constants.FIELD_NAMES.POND_DRIFT,
                        editable: isProjectOwnershipValid,
                        wrapHeaderText: true,
                        autoHeaderHeight: true,
                        minWidth: 95,
                        width: 105,
                        maxWidth: 120,
                        type: 'leftAligned',
                        filter: 'agSetColumnFilter',
                    },
                ],
            },
            {
                headerName: 'Custom',
                children: [
                    {
                        headerName: 'Efficiency',
                        field: Constants.FIELD_NAMES.CUSTOM_EFFICIENCY,
                        editable: isProjectOwnershipValid,
                        hide: !selectedProject || isPwcV2Project(selectedProject),
                        wrapHeaderText: true,
                        autoHeaderHeight: true,
                        minWidth: 110,
                        width: 110,
                        maxWidth: 120,
                        type: 'leftAligned',
                        filter: 'agSetColumnFilter',
                    },
                    {
                        headerName: 'Drift',
                        field: Constants.FIELD_NAMES.CUSTOM_DRIFT,
                        editable: isProjectOwnershipValid,
                        hide: !selectedProject || isPwcV2Project(selectedProject),
                        wrapHeaderText: true,
                        autoHeaderHeight: true,
                        minWidth: 95,
                        width: 105,
                        maxWidth: 120,
                        type: 'leftAligned',
                        filter: 'agSetColumnFilter',
                    },
                ],
            },
        ];
    }
}
